import { chipColours } from '../lib/score';

/** The score as a pill (Home and Library mockups), shaded along the score scale. */
export function ScoreChip({ score, large = false }: { score: number | null; large?: boolean }) {
  const colours = chipColours(score);
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-bold tabular-nums ${large ? 'h-8 px-3 text-[16px]' : 'h-[22px] px-2 text-[12px]'}`}
      style={colours}
    >
      {score === null ? 'Unrated' : score.toFixed(1)}
    </span>
  );
}
